import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import helpContent from "../utils/helpContent";
import { FaStarHalfAlt } from "react-icons/fa";

export default function FloatingHelpButton() {
    const [showModal, setShowModal] = useState(false);
    const location = useLocation();
    const userType = localStorage.getItem("userType")
    let content 
    if(userType=="individual" && location.pathname=="/"){
        content = helpContent['/student-dashboard']
    }else{
        content = helpContent[location.pathname];
    }

    const modalVariants = {
        hidden: {
            opacity: 0,
            scale: 0.6,
            x: 100,
            y: 100
        },
        visible: {
            opacity: 1,
            scale: 1,
            x: 0,
            y: 0,
            transition: { type: "spring", stiffness: 300, damping: 20 }
        },
        exit: {
            opacity: 0,
            scale: 0.6,
            x: 100,
            y: 100,
            transition: { type: "tween", duration: 0.2 }
        }
    };

    return (
        <>
            <button
                onClick={() => setShowModal(true)}
                className="fixed bottom-5 right-5 w-10 h-10 rounded-full text-xl font-bold text-white z-50 shadow-lg btn-gradient-help  overflow-hidden flex items-center justify-center"
                title="Help"
            >
                ?
                <span className="absolute top-0 left-0 w-full h-full rounded-full bg-white/20 pointer-events-none" />
            </button>

            <AnimatePresence>
                {showModal && (
                    <motion.div
                        className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50"
                        onClick={() => setShowModal(false)}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                    >
                        <motion.div
                            onClick={(e) => e.stopPropagation()}
                            variants={modalVariants}
                            className="relative bg-white p-6 rounded-xl w-[90%] max-h-[80vh] overflow-y-auto max-w-5xl shadow-xl custom-scroll"
                        >
                            {/* Close Icon Button */}
                            <button
                                onClick={() => setShowModal(false)}
                                className="absolute top-3 right-3 text-gray-600 hover:text-gray-900 text-2xl"
                                aria-label="Close"
                            >
                                &times;
                            </button>

                            {/* Help Content */}
                            <h2 className="text-xl font-bold mb-4">
                                {content?.title || "Help"}
                            </h2>
                            {content?.points?.length ? (
                                <ul className="space-y-3">
                                    {content.points.map((point, index) => (
                                        <li key={index} className="flex items-center gap-4 text-gray-700">
                                            <FaStarHalfAlt size={12} className="text-gray-600 flex-shrink-0" />
                                            <span>{point}</span>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p className="text-gray-700">No help info available for this page.</p>
                            )}

                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
}
